/*
 * AUTOGENERATED - DON'T EDIT
 * Your edits in this file will be overwritten in the next build!
 * Modify the docusaurus.config.js file at your site's root instead.
 */
export default {
  "title": "Armageddon",
  "tagline": "Servidor brasileiro de Minecraft Survival SMP Semi-Anarquia",
  "url": "https://armamc.net",
  "baseUrl": "/",
  "onBrokenLinks": "warn",
  "markdown": {
    "hooks": {
      "onBrokenMarkdownLinks": "warn",
      "onBrokenMarkdownImages": "throw"
    },
    "format": "mdx",
    "mermaid": false,
    "emoji": true,
    "mdx1Compat": {
      "comments": true,
      "admonitions": true,
      "headingIds": true
    },
    "anchors": {
      "maintainCase": false
    }
  },
  "favicon": "img/favicon.ico",
  "organizationName": "ArmaRealms",
  "projectName": "armamc.net",
  "trailingSlash": true,
  "deploymentBranch": "gh-pages",
  "i18n": {
    "defaultLocale": "pt-BR",
    "locales": [
      "pt-BR"
    ],
    "path": "i18n",
    "localeConfigs": {}
  },
  "presets": [
    [
      "classic",
      {
        "pages": {
          "routeBasePath": "/"
        },
        "docs": {
          "sidebarPath": "/opt/buildhome/repo/sidebars.js",
          "routeBasePath": "/wiki"
        },
        "blog": {
          "showReadingTime": true,
          "showLastUpdateTime": true,
          "routeBasePath": "/blog",
          "blogTitle": "Blog de Minecraft do Armageddon",
          "blogDescription": "Notícias, guias e atualizações do servidor brasileiro de Minecraft Armageddon: Survival SMP Semi-Anarquia."
        },
        "theme": {
          "customCss": "/opt/buildhome/repo/src/css/custom.css"
        },
        "sitemap": {
          "changefreq": "weekly",
          "priority": 0.5,
          "filename": "sitemap.xml",
          "ignorePatterns": [
            "**/404.html",
            "**/404",
            "**/blog/404.html",
            "**/blog/404",
            "**/404.html"
          ]
        }
      }
    ]
  ],
  "themeConfig": {
    "image": "img/banner/spawn.png",
    "navbar": {
      "logo": {
        "alt": "armamc",
        "src": "img/logo.png",
        "href": "/"
      },
      "items": [
        {
          "to": "/",
          "position": "left",
          "label": "Home",
          "exact": true
        },
        {
          "href": "https://loja.armamc.com/",
          "position": "left",
          "label": "Loja"
        },
        {
          "to": "jogar",
          "position": "left",
          "label": "Jogar"
        },
        {
          "to": "servidor-minecraft",
          "position": "left",
          "label": "Servidor"
        },
        {
          "to": "vote",
          "position": "left",
          "label": "Vote"
        },
        {
          "to": "blog",
          "position": "left",
          "label": "Blog"
        },
        {
          "type": "dropdown",
          "position": "left",
          "to": "wiki",
          "label": "Wiki",
          "items": [
            {
              "to": "wiki/survival",
              "label": "Survival"
            },
            {
              "to": "wiki/skyblock",
              "label": "Skyblock"
            },
            {
              "to": "wiki/semi-anarquia",
              "label": "Semi-Anarquia"
            }
          ]
        },
        {
          "type": "dropdown",
          "to": "regras",
          "position": "left",
          "label": "Regras",
          "items": [
            {
              "href": "/regras/#01",
              "label": "Regra 01 - Enviar Xingamentos!"
            },
            {
              "href": "/regras/#02",
              "label": "Regra 02 - Usar Métodos para Obter Vantagens!"
            },
            {
              "href": "/regras/#03",
              "label": "Regra 03 - Destruir o Mapa ou Construções!"
            },
            {
              "href": "/regras/#04",
              "label": "Regra 04 - Fazer Spam ou Flood!"
            },
            {
              "href": "/regras/#05",
              "label": "Regra 05 - Fazer Armadilha ou Chat Falso!"
            },
            {
              "href": "/regras/#06",
              "label": "Regra 06 - Acumular Entidades em Excesso!"
            },
            {
              "href": "/regras/#07",
              "label": "Regra 07 - Abusar de Circuitos de Redstone!"
            },
            {
              "href": "/regras/#08",
              "label": "Regra 08 - Praticar Ações Antijogo!"
            },
            {
              "href": "/regras/#09",
              "label": "Regra 09 - Utilizar Nickname Inapropriado!"
            },
            {
              "href": "/regras/#10",
              "label": "Regra 10 - Utilizar Skin Inapropriada!"
            },
            {
              "href": "/regras/#11",
              "label": "Regra 11 - Divulgar outros Servidores!"
            },
            {
              "href": "/regras/#12",
              "label": "Regra 12 - MapArts ou Construções Obscenas!"
            },
            {
              "href": "/regras/#13",
              "label": "Regra 13 - Comércio Externo de Itens ou Conta!"
            },
            {
              "href": "/regras/#14",
              "label": "Regra 14 - Burlar Punição!"
            },
            {
              "href": "/regras/#15",
              "label": "Regra 15 - Discurso de Ódio!"
            },
            {
              "href": "/regras/#16",
              "label": "Regra 16 - Praticar Doxxing!"
            },
            {
              "href": "/regras/#17",
              "label": "Regra 17 - Abusar de Erros!"
            },
            {
              "href": "/regras/#18",
              "label": "Regra 18 - Compartilhamento de Conta!"
            }
          ]
        },
        {
          "type": "dropdown",
          "position": "left",
          "label": "Outros",
          "items": [
            {
              "to": "form",
              "label": "Formulário"
            },
            {
              "to": "gradiente",
              "label": "Gradiente"
            },
            {
              "to": "blog/guia/textura",
              "label": "Textura"
            },
            {
              "to": "equipe",
              "label": "Equipe"
            },
            {
              "to": "meuip",
              "label": "Consultar seu IP"
            },
            {
              "to": "ideias-de-videos",
              "label": "Ideias para Vídeos"
            }
          ]
        },
        {
          "href": "https://discord.gg/armamc",
          "className": "header-icon-link header-discord-link",
          "position": "right"
        }
      ],
      "hideOnScroll": true,
      "title": ""
    },
    "prism": {
      "darkTheme": {
        "plain": {
          "color": "#F8F8F2",
          "backgroundColor": "#282A36"
        },
        "styles": [
          {
            "types": [
              "prolog",
              "constant",
              "builtin"
            ],
            "style": {
              "color": "rgb(189, 147, 249)"
            }
          },
          {
            "types": [
              "inserted",
              "function"
            ],
            "style": {
              "color": "rgb(80, 250, 123)"
            }
          },
          {
            "types": [
              "deleted"
            ],
            "style": {
              "color": "rgb(255, 85, 85)"
            }
          },
          {
            "types": [
              "changed"
            ],
            "style": {
              "color": "rgb(255, 184, 108)"
            }
          },
          {
            "types": [
              "punctuation",
              "symbol"
            ],
            "style": {
              "color": "rgb(248, 248, 242)"
            }
          },
          {
            "types": [
              "string",
              "char",
              "tag",
              "selector"
            ],
            "style": {
              "color": "rgb(255, 121, 198)"
            }
          },
          {
            "types": [
              "keyword",
              "variable"
            ],
            "style": {
              "color": "rgb(189, 147, 249)",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "comment"
            ],
            "style": {
              "color": "rgb(98, 114, 164)"
            }
          },
          {
            "types": [
              "attr-name"
            ],
            "style": {
              "color": "rgb(241, 250, 140)"
            }
          }
        ]
      },
      "theme": {
        "plain": {
          "color": "#bfc7d5",
          "backgroundColor": "#292d3e"
        },
        "styles": [
          {
            "types": [
              "comment"
            ],
            "style": {
              "color": "rgb(105, 112, 152)",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "string",
              "inserted"
            ],
            "style": {
              "color": "rgb(195, 232, 141)"
            }
          },
          {
            "types": [
              "number"
            ],
            "style": {
              "color": "rgb(247, 140, 108)"
            }
          },
          {
            "types": [
              "builtin",
              "char",
              "constant",
              "function"
            ],
            "style": {
              "color": "rgb(130, 170, 255)"
            }
          },
          {
            "types": [
              "punctuation",
              "selector"
            ],
            "style": {
              "color": "rgb(199, 146, 234)"
            }
          },
          {
            "types": [
              "variable"
            ],
            "style": {
              "color": "rgb(191, 199, 213)"
            }
          },
          {
            "types": [
              "class-name",
              "attr-name"
            ],
            "style": {
              "color": "rgb(255, 203, 107)"
            }
          },
          {
            "types": [
              "tag",
              "deleted"
            ],
            "style": {
              "color": "rgb(255, 85, 114)"
            }
          },
          {
            "types": [
              "operator"
            ],
            "style": {
              "color": "rgb(137, 221, 255)"
            }
          },
          {
            "types": [
              "boolean"
            ],
            "style": {
              "color": "rgb(255, 88, 116)"
            }
          },
          {
            "types": [
              "keyword"
            ],
            "style": {
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "doctype"
            ],
            "style": {
              "color": "rgb(199, 146, 234)",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "namespace"
            ],
            "style": {
              "color": "rgb(178, 204, 214)"
            }
          },
          {
            "types": [
              "url"
            ],
            "style": {
              "color": "rgb(221, 221, 221)"
            }
          }
        ]
      },
      "additionalLanguages": [],
      "magicComments": [
        {
          "className": "theme-code-block-highlighted-line",
          "line": "highlight-next-line",
          "block": {
            "start": "highlight-start",
            "end": "highlight-end"
          }
        }
      ]
    },
    "colorMode": {
      "defaultMode": "dark",
      "disableSwitch": true,
      "respectPrefersColorScheme": false
    },
    "metadata": [
      {
        "name": "twitter:card",
        "content": "summary_large_image"
      },
      {
        "name": "theme-color",
        "content": "#d26752"
      },
      {
        "property": "og:site_name",
        "content": "Armageddon Server"
      }
    ],
    "footer": {
      "logo": {
        "alt": "Logo do Armageddon Server",
        "src": "img/favicon.ico",
        "href": "https://armamc.net/wiki",
        "width": 25,
        "height": 25
      },
      "copyright": "Copyright © 2025 Armageddon Server - Não somos afiliados a Mojang AB.",
      "style": "light",
      "links": []
    },
    "docs": {
      "versionPersistence": "localStorage",
      "sidebar": {
        "hideable": false,
        "autoCollapseCategories": false
      }
    },
    "blog": {
      "sidebar": {
        "groupByYear": true
      }
    },
    "tableOfContents": {
      "minHeadingLevel": 2,
      "maxHeadingLevel": 3
    }
  },
  "themes": [
    [
      "@easyops-cn/docusaurus-search-local",
      {
        "docsDir": "/docs",
        "docsRouteBasePath": "/wiki",
        "indexBlog": true,
        "indexPages": true,
        "language": [
          "pt"
        ],
        "highlightSearchTermsOnTargetPage": true,
        "explicitSearchResultPath": true,
        "searchResultContextMaxLength": 80,
        "removeDefaultStemmer": true
      }
    ]
  ],
  "plugins": [
    [
      "docusaurus-plugin-llms",
      {
        "generateLLMsTxt": true,
        "generateLLMsFullTxt": true,
        "docsDir": "docs",
        "title": "Armageddon: servidor Minecraft e guias oficiais",
        "description": "Conheça os modos e sistemas do servidor brasileiro Armageddon e encontre documentação oficial.",
        "includeBlog": true,
        "excludeImports": true,
        "removeDuplicateHeadings": true,
        "generateMarkdownFiles": true,
        "includeUnmatchedLast": true,
        "rootContent": "## Guias principais do servidor\n\nAs páginas abaixo apresentam os modos e sistemas do Armageddon. A Wiki vinculada em cada página é a fonte técnica oficial.\n\n- [Servidor de Minecraft: conheça o Armageddon](https://armamc.net/servidor-minecraft/): Conheça o servidor brasileiro Armageddon, escolha entre Survival e SMP Semi-Anarquia e explore os sistemas e guias oficiais.\n- [Servidor brasileiro de Minecraft com três modos](https://armamc.net/servidor-minecraft-brasileiro/): Jogue no servidor brasileiro Armageddon: Survival e SMP Semi-Anarquia, com acesso por Java e Bedrock e guias oficiais em português.\n- [Survival para construir, evoluir e jogar em comunidade](https://armamc.net/servidor-minecraft-survival/): Conheça o Survival do Armageddon: exploração, proteção de construções, economia entre jogadores, mcMMO, clãs, desafios e torneios.\n- [Skyblock: transforme uma ilha em seu projeto](https://armamc.net/servidor-minecraft-skyblock/): Comece em uma ilha no Skyblock do Armageddon e explore missões, fábricas, habilidades, melhorias de ilha e dungeons.\n- [SMP Semi-Anarquia: um SMP com PvP e alianças](https://armamc.net/servidor-minecraft-semi-anarquia/): Conheça a SMP Semi-Anarquia do Armageddon, um modo SMP de sobrevivência multiplayer com PvP, alianças, economia e disputa entre jogadores.\n- [Economia do Survival: comércio com diferentes ferramentas](https://armamc.net/servidor-minecraft-com-economia/): Veja como a economia do Survival no Armageddon conecta lojas do servidor, lojas de jogadores, leilão, pedidos e comércio em coins.\n- [Proteja suas construções no Survival](https://armamc.net/servidor-minecraft-com-protecao-de-terreno/): Conheça os claims do Survival do Armageddon: crie e amplie proteções, administre permissões e consulte os guias antes de construir.\n- [Clãs, Liga e competição no Survival](https://armamc.net/servidor-minecraft-com-clans/): Forme um clã no Survival do Armageddon, organize cargos e aliados e conheça a Liga, os duelos e as guerras entre grupos.\n- [mcMMO: habilidades que evoluem com suas atividades](https://armamc.net/servidor-minecraft-com-mcmmo/): Evolua habilidades mcMMO no Survival do Armageddon, incluindo mineração, pescaria, combate, reparo e outras especializações.\n- [Eventos para mudar o ritmo do Minecraft](https://armamc.net/servidor-minecraft-com-eventos/): Participe de eventos no Armageddon, de minijogos como Block Party e TNT Run a atividades sazonais documentadas na Wiki.\n- [Torneios e objetivos competitivos no Survival](https://armamc.net/servidor-minecraft-com-torneios/): Conheça os torneios do Survival do Armageddon, acompanhe categorias competitivas e consulte as regras oficiais antes de participar.\n- [Entre pelo Minecraft Java ou Bedrock](https://armamc.net/servidor-minecraft-com-java-bedrock/): Entre no Armageddon pelo Minecraft Java ou Bedrock usando armamc.net. Veja as portas oficiais e saiba como vincular contas.\n- [Chat de voz por proximidade no Armageddon](https://armamc.net/servidor-minecraft-com-voice-chat/): Use o Simple Voice Chat no Armageddon para conversar por proximidade, configurar ativação por voz ou pressionar para falar.\n- [Lojas de jogadores no mundo Survival](https://armamc.net/servidor-minecraft-com-loja-de-jogadores/): Crie ou visite lojas físicas de jogadores no Survival do Armageddon e consulte os comandos oficiais para comprar e vender itens.\n- [Leilão virtual para negociar no Survival](https://armamc.net/servidor-minecraft-com-leilao/): Negocie pelo leilão virtual do Survival do Armageddon: anuncie itens, consulte ofertas e confira as regras e comandos oficiais.\n- [Fábricas e automação no Skyblock](https://armamc.net/servidor-minecraft-com-fabricas/): Conheça as fábricas do Skyblock do Armageddon e como Pontos de Pesquisa se relacionam a desbloqueios, receitas e melhorias.\n- [Dungeons para explorar no Skyblock](https://armamc.net/servidor-minecraft-com-dungeons/): Explore dungeons no Skyblock do Armageddon: áreas temáticas com combate, exploração e desafios descritos nos guias oficiais.",
        "fullRootContent": "## Guias editoriais do Armageddon\n\nAs páginas abaixo são resumos editoriais ligados aos guias técnicos oficiais. Consulte a URL canônica ou a Wiki vinculada para instruções operacionais atualizadas.\n\n## Servidor de Minecraft: conheça o Armageddon\n\nURL canônica: https://armamc.net/servidor-minecraft/\n\nConheça o servidor brasileiro Armageddon, escolha entre Survival e SMP Semi-Anarquia e explore os sistemas e guias oficiais.\n\nO Armageddon é um servidor brasileiro de Minecraft com os modos Survival e SMP Semi-Anarquia. A comunidade pode entrar pelo Java ou Bedrock e encontrar sistemas próprios de economia, construção, progressão e competição. Use este guia para escolher um modo e saber onde aprender cada mecânica.\n\nDocumentação técnica: https://armamc.net/wiki/\n\n---\n\n## Servidor brasileiro de Minecraft com três modos\n\nURL canônica: https://armamc.net/servidor-minecraft-brasileiro/\n\nJogue no servidor brasileiro Armageddon: Survival e SMP Semi-Anarquia, com acesso por Java e Bedrock e guias oficiais em português.\n\nArmageddon é uma comunidade brasileira de Minecraft com mundos e estilos de jogo diferentes. Você pode escolher entre construir e progredir no Survival, desenvolver uma ilha no Skyblock ou encarar a sobrevivência PvP da SMP Semi-Anarquia.\n\n### Escolha a experiência\n\nNo Survival, exploração, proteção de terrenos, economia e clãs estruturam a jornada. O Skyblock começa em uma ilha e oferece missões, fábricas, skills e dungeons. Já a SMP Semi-Anarquia é um SMP com PvP, alianças e disputa entre jogadores.\n\n### Acesso pelo Java ou Bedrock\n\nO servidor aceita conexões Java e Bedrock. O endereço é armamc.net; use a porta 25565 no Java e 19132 no Bedrock. As instruções de conexão e de vinculação de contas estão na página Jogar.\n\n### Comece com informação oficial\n\nOs artigos desta seção apresentam os sistemas e ajudam a escolher por onde começar. Para comandos, regras específicas e tutoriais detalhados, consulte a Wiki oficial, que continua sendo a referência técnica do servidor.\n\n### Qual é o endereço do servidor?\n\nO endereço é armamc.net. A porta Java é 25565 e a porta Bedrock é 19132.\n\n### Quais modos estão disponíveis?\n\nSurvival e SMP Semi-Anarquia.\n\nDocumentação técnica: https://armamc.net/wiki/\n\n---\n\n## Survival para construir, evoluir e jogar em comunidade\n\nURL canônica: https://armamc.net/servidor-minecraft-survival/\n\nConheça o Survival do Armageddon: exploração, proteção de construções, economia entre jogadores, mcMMO, clãs, desafios e torneios.\n\nO Survival do Armageddon combina exploração de mundo aberto com sistemas que dão objetivos para além de coletar recursos. Construa sua base, proteja áreas, desenvolva habilidades e participe das atividades do servidor no seu próprio ritmo.\n\n### Construa com proteção\n\nClaims delimitam áreas protegidas e podem ser criados e ampliados pelos comandos documentados na Wiki. Permissões permitem administrar quem interage com o terreno; consulte as regras de inatividade antes de deixar uma proteção parada por muito tempo.\n\n### Progrida em várias frentes\n\nO modo reúne economia com lojas e leilão, habilidades mcMMO, desafios diários, torneios semanais e atividades de clãs. Cada sistema tem seu próprio guia, então você pode aprender somente o que combina com seu estilo.\n\n### Uma jornada compartilhada\n\nJogue sozinho, faça comércio ou forme um clã para participar da Liga e de eventos competitivos. A Wiki explica regras e comandos; a página de entrada mostra como conectar pelo Java ou Bedrock.\n\nDocumentação técnica: https://armamc.net/wiki/survival/\n\n---\n\n## Skyblock: transforme uma ilha em seu projeto\n\nURL canônica: https://armamc.net/servidor-minecraft-skyblock/\n\nComece em uma ilha no Skyblock do Armageddon e explore missões, fábricas, habilidades, melhorias de ilha e dungeons.\n\nNo Skyblock do Armageddon, a progressão começa com uma ilha e depende de como você administra espaço, recursos e objetivos. Escolha uma ilha inicial, avance pelas missões e descubra sistemas próprios para expandir sua experiência.\n\n### Desenvolva a ilha\n\nA Wiki documenta criação, gerenciamento, melhorias, permissões, proteção e warps. Esses guias ajudam a organizar o espaço e a compartilhar a ilha de acordo com as ferramentas disponíveis no servidor.\n\n### Pesquise e automatize\n\nAs fábricas produzem recursos e se conectam aos Pontos de Pesquisa, usados para desbloquear ou aprimorar fábricas, receitas e habilidades. Consulte os requisitos de cada sistema antes de planejar a produção.\n\n### Alterne entre construção e aventura\n\nMissões e skills oferecem objetivos de progressão, enquanto dungeons apresentam áreas de exploração e combate com temáticas diferentes. Os guias oficiais descrevem cada atividade sem misturar instruções técnicas com a apresentação do modo.\n\nDocumentação técnica: https://armamc.net/wiki/skyblock/\n\n---\n\n## SMP Semi-Anarquia: um SMP com PvP e alianças\n\nURL canônica: https://armamc.net/servidor-minecraft-semi-anarquia/\n\nConheça a SMP Semi-Anarquia do Armageddon, um modo SMP de sobrevivência multiplayer com PvP, alianças, economia e disputa entre jogadores.\n\nA SMP Semi-Anarquia do Armageddon é um modo de sobrevivência multiplayer em que jogadores decidem como explorar, construir, competir e cooperar. PvP, alianças e disputas fazem parte da experiência; cada grupo escolhe como enfrentar o mundo e os demais jogadores.\n\n### Forme seu time\n\nO sistema de times permite organizar aliados. A documentação oficial explica os comandos disponíveis e o funcionamento do grupo; consulte-a antes de compartilhar acesso ou recursos com outros jogadores.\n\n### Use os sistemas do modo\n\nA economia da SMP Semi-Anarquia tem documentação própria para money, éteres, leilão e pedidos. Há também páginas de teleporte, duelo, caixas e chat de voz para quem quiser conhecer esses recursos.\n\n### Sobrevivência com decisões próprias\n\nO modo não exige uma única forma de jogar: você pode priorizar exploração, comércio, combate ou alianças. Leia os guias e as regras do servidor para entender os limites de cada sistema.\n\nDocumentação técnica: https://armamc.net/wiki/semi-anarquia/\n\n---\n\n## Economia do Survival: comércio com diferentes ferramentas\n\nURL canônica: https://armamc.net/servidor-minecraft-com-economia/\n\nVeja como a economia do Survival no Armageddon conecta lojas do servidor, lojas de jogadores, leilão, pedidos e comércio em coins.\n\nA economia do Survival oferece mais de uma forma de negociar. A Wiki documenta a loja do servidor, as lojas físicas criadas por jogadores, o leilão virtual, os pedidos e o extrato. Cada ferramenta atende a uma situação de compra ou venda diferente.\n\n### Escolha onde negociar\n\nA loja do servidor usa menus e comandos para comprar ou vender itens compatíveis. Lojas físicas permitem que jogadores mantenham pontos de comércio no mundo e definam itens, quantidades e preços.\n\n### Negocie mesmo fora de uma loja física\n\nO leilão virtual permite listar itens e consultar ofertas usando o saldo em coins, enquanto os pedidos registram itens procurados. Leia as regras e limites documentados para cada ferramenta antes de anunciar.\n\n### Aprenda os comandos com a Wiki\n\nEsta página apresenta os caminhos de comércio; não substitui os procedimentos atualizados nem as tabelas de cargos. Os comandos detalhados e suas condições estão nos artigos oficiais de economia.\n\nDocumentação técnica: https://armamc.net/wiki/survival/economia/\n\n---\n\n## Proteja suas construções no Survival\n\nURL canônica: https://armamc.net/servidor-minecraft-com-protecao-de-terreno/\n\nConheça os claims do Survival do Armageddon: crie e amplie proteções, administre permissões e consulte os guias antes de construir.\n\nNo Survival do Armageddon, o sistema de proteção permite demarcar terrenos para proteger construções. Claims podem ser criados, ampliados, inspecionados e administrados; a Wiki detalha os comandos e as condições para cada ação.\n\n### Demarque sua área\n\nA documentação apresenta a criação de proteção com pá de ouro ou com o comando `/claim`, além das opções para consultar e expandir uma área. Os exemplos oficiais mostram como identificar os limites no mundo.\n\n### Administre acessos\n\nAs permissões determinam o que outras pessoas podem fazer na sua proteção. Revise as permissões e os subclaims antes de convidar alguém para construir ou interagir com itens.\n\n### Entenda a manutenção\n\nAs proteções têm regras relacionadas ao tamanho e ao tempo offline do dono. Confira a página sobre perda de proteção e os artigos de gerenciamento antes de depender de uma área por longo prazo.\n\nDocumentação técnica: https://armamc.net/wiki/survival/protecao/\n\n---\n\n## Clãs, Liga e competição no Survival\n\nURL canônica: https://armamc.net/servidor-minecraft-com-clans/\n\nForme um clã no Survival do Armageddon, organize cargos e aliados e conheça a Liga, os duelos e as guerras entre grupos.\n\nOs clãs do Survival organizam jogadores em grupos com cargos, aliados e ferramentas de gestão. A Liga de Clãs e os modos competitivos documentados oferecem objetivos para quem quer levar o jogo em equipe além da construção.\n\n### Organize o grupo\n\nA Wiki explica criação de clã, convites, confiáveis, cargos, base e banco. Como algumas ações são irreversíveis ou têm requisitos, leia as instruções antes de criar ou alterar um grupo.\n\n### Compita em equipe\n\nA Liga de Clãs tem páginas próprias sobre pontuação, regras e premiações. Há também documentação sobre Guerra de Clãs e duelos, que descreve como participar dessas atividades.\n\n### Combine estratégia e comunidade\n\nDefinir responsabilidades e permissões ajuda o clã a operar com mais clareza. Para os detalhes de comandos e regras, use a Wiki oficial em vez de depender de resumos de terceiros.\n\nDocumentação técnica: https://armamc.net/wiki/survival/clan/\n\n---\n\n## mcMMO: habilidades que evoluem com suas atividades\n\nURL canônica: https://armamc.net/servidor-minecraft-com-mcmmo/\n\nEvolua habilidades mcMMO no Survival do Armageddon, incluindo mineração, pescaria, combate, reparo e outras especializações.\n\nO mcMMO do Survival agrupa habilidades ligadas a atividades como mineração, combate, coleta e criação. Ao jogar, você pode desenvolver especializações e desbloquear efeitos descritos nos guias de cada habilidade.\n\n### Progrida fazendo atividades\n\nA habilidade de Mineração, por exemplo, recebe experiência ao minerar blocos compatíveis e inclui efeitos como Super Furadeira, Drops Duplos e Mineração Explosiva. Os requisitos variam entre habilidades, portanto consulte cada artigo.\n\n### Escolha sua especialização\n\nA Wiki lista habilidades como Pescaria, Alquimia, Lenhador, Herbalismo, Reparo, Acrobacia, Arquearia, Espadas, Machados e outras. A página de cada uma explica como ganhar experiência e quais efeitos estão disponíveis.\n\n### Consulte detalhes antes de planejar\n\nNíveis, materiais compatíveis e funcionamento de efeitos pertencem à documentação técnica. Esta apresentação ajuda a descobrir o sistema, mas não substitui a Wiki para números ou comandos atualizados.\n\nDocumentação técnica: https://armamc.net/wiki/survival/mcmmo/\n\n---\n\n## Eventos para mudar o ritmo do Minecraft\n\nURL canônica: https://armamc.net/servidor-minecraft-com-eventos/\n\nParticipe de eventos no Armageddon, de minijogos como Block Party e TNT Run a atividades sazonais documentadas na Wiki.\n\nOs eventos do Armageddon oferecem partidas e atividades diferentes da progressão tradicional dos modos. A Wiki organiza as atividades por frequência e descreve regras, mecânicas e instruções de participação quando disponíveis.\n\n### Minijogos e desafios\n\nEntre os eventos documentados estão Block Party, TNT Run, Parkour, Spleef, Splegg, Sumo, Paintball, Quake Craft, Rei da Colina e Um na Câmara. Cada atividade tem suas próprias regras e dinâmica.\n\n### Atividades em vários ritmos\n\nA documentação está separada em eventos diários, semanais, mensais e anuais. Confira a Wiki para saber como participar e quais regras se aplicam; a programação pode mudar ao longo do tempo.\n\n### Jogue com outras pessoas\n\nAlgumas atividades são individuais e outras envolvem equipes ou clãs. A página de cada evento apresenta o formato específico, para que você saiba o que esperar antes de entrar.\n\nDocumentação técnica: https://armamc.net/wiki/survival/eventos/\n\n---\n\n## Torneios e objetivos competitivos no Survival\n\nURL canônica: https://armamc.net/servidor-minecraft-com-torneios/\n\nConheça os torneios do Survival do Armageddon, acompanhe categorias competitivas e consulte as regras oficiais antes de participar.\n\nOs torneios do Survival são uma forma de acompanhar disputas e metas entre jogadores. A Wiki mantém uma lista de categorias e artigos próprios com informações sobre cada torneio.\n\n### Mais de uma forma de competir\n\nAs categorias documentadas incluem atividades ligadas a mineração, pesca, construção, exploração, comércio, combate e outras ações do servidor. Cada uma mede um tipo diferente de progresso.\n\n### Consulte os critérios oficiais\n\nRegras, comandos e critérios podem variar por categoria. Use a documentação oficial para conferir o funcionamento vigente e evitar depender de uma descrição desatualizada.\n\n### Competição conectada ao Survival\n\nTorneios complementam a exploração e os sistemas do modo: você pode desenvolver habilidades, negociar ou construir enquanto busca objetivos competitivos.\n\nDocumentação técnica: https://armamc.net/wiki/survival/torneios/\n\n---\n\n## Entre pelo Minecraft Java ou Bedrock\n\nURL canônica: https://armamc.net/servidor-minecraft-com-java-bedrock/\n\nEntre no Armageddon pelo Minecraft Java ou Bedrock usando armamc.net. Veja as portas oficiais e saiba como vincular contas.\n\nO Armageddon aceita jogadores de Minecraft Java e Bedrock. Use armamc.net como endereço do servidor e selecione a porta correspondente à sua edição para adicionar o servidor no jogo.\n\n### Endereço e portas oficiais\n\nJava Edition: armamc.net, porta 25565. Bedrock Edition: armamc.net, porta 19132. O guia de entrada mostra o passo a passo para cada plataforma.\n\n### Vincule contas quando necessário\n\nA documentação explica como vincular uma conta Java à Bedrock para carregar os dados da conta Java ao entrar pela Bedrock. O processo usa comandos executados dentro do servidor e um código temporário.\n\n### Use o guia da sua edição\n\nAs telas e etapas variam entre plataformas. Abra o tutorial Java ou Bedrock antes de conectar e consulte a página de vinculação se for usar o progresso de uma conta Java na Bedrock.\n\n### Qual porta usar no Java?\n\nA porta documentada para Java Edition é 25565.\n\n### Qual porta usar no Bedrock?\n\nA porta documentada para Bedrock Edition é 19132.\n\nDocumentação técnica: https://armamc.net/jogar/\n\n---\n\n## Chat de voz por proximidade no Armageddon\n\nURL canônica: https://armamc.net/servidor-minecraft-com-voice-chat/\n\nUse o Simple Voice Chat no Armageddon para conversar por proximidade, configurar ativação por voz ou pressionar para falar.\n\nO guia oficial do Armageddon documenta o Simple Voice Chat, um mod que adiciona comunicação por voz por proximidade. Com ele, jogadores podem conversar perto uns dos outros sem depender apenas do chat de texto.\n\n### Configure a forma de falar\n\nO mod oferece pressionar para falar (PTT) e ativação por voz. A tecla padrão de PTT é definida ao configurar o mod pela primeira vez; a tecla V abre o menu de ajustes.\n\n### Ajuste a experiência\n\nAs opções documentadas incluem teste de microfone, ajuste individual do volume, sussurro e controles de áudio. O guia também lista compatibilidade com Fabric, Forge e Quilt.\n\n### Instale pelo guia oficial\n\nConsulte o tutorial do servidor e a página oficial do projeto para obter o mod compatível e configurar o cliente. Os recursos de voz dependem da configuração do jogador e do mod instalado.\n\nDocumentação técnica: https://armamc.net/wiki/survival/chat-voz/simple-voice-chat/\n\n---\n\n## Lojas de jogadores no mundo Survival\n\nURL canônica: https://armamc.net/servidor-minecraft-com-loja-de-jogadores/\n\nCrie ou visite lojas físicas de jogadores no Survival do Armageddon e consulte os comandos oficiais para comprar e vender itens.\n\nNo Survival do Armageddon, jogadores podem criar lojas físicas para comprar ou vender itens usando baús e placas. O sistema faz parte da economia entre jogadores e está ligado às proteções de terreno.\n\n### Uma vitrine dentro do mundo\n\nUma loja física permite que outros jogadores negociem itens em um local construído no mapa. A documentação explica criação por interação ou comando, configuração do item, preço e modo de compra ou venda.\n\n### Encontre ofertas\n\nOs comandos de busca permitem localizar lojas que compram ou vendem determinado item. Confira na Wiki como pesquisar pelo tipo ou nome e como concluir uma compra.\n\n### Proteção e regras\n\nLojas físicas dependem do sistema de proteção e são removidas quando a proteção associada é excluída. Custos e limites podem depender das regras e cargos vigentes; consulte o artigo oficial antes de planejar uma loja.\n\nDocumentação técnica: https://armamc.net/wiki/survival/economia/ploja/\n\n---\n\n## Leilão virtual para negociar no Survival\n\nURL canônica: https://armamc.net/servidor-minecraft-com-leilao/\n\nNegocie pelo leilão virtual do Survival do Armageddon: anuncie itens, consulte ofertas e confira as regras e comandos oficiais.\n\nO leilão virtual do Survival permite anunciar itens e acessar ofertas sem estar no local de uma loja física. A Wiki descreve o menu, os comandos para vender ou leiloar e as formas de pagamento documentadas.\n\n### Anuncie e consulte ofertas\n\nO menu `/ah` ou `/leilao` abre o sistema. O artigo oficial também explica como listar itens, abrir categorias e acessar a mochila quando o inventário está cheio.\n\n### Confira cada opção antes de usar\n\nHá comandos distintos para vender ou leiloar itens e opções relacionadas a coins e cash. Quantidade máxima de anúncios e tempo de permanência dependem do cargo e estão especificados na documentação.\n\n### Compare as ferramentas de comércio\n\nUse lojas físicas para negociar em pontos do mundo e o leilão para consultar ofertas virtuais. A página geral de economia reúne esses caminhos e liga a outros sistemas.\n\nDocumentação técnica: https://armamc.net/wiki/survival/economia/leilao/\n\n---\n\n## Fábricas e automação no Skyblock\n\nURL canônica: https://armamc.net/servidor-minecraft-com-fabricas/\n\nConheça as fábricas do Skyblock do Armageddon e como Pontos de Pesquisa se relacionam a desbloqueios, receitas e melhorias.\n\nAs fábricas são um dos sistemas de progressão do Skyblock do Armageddon. Elas permitem produzir recursos e se conectam aos Pontos de Pesquisa, usados para desbloquear ou aprimorar fábricas, receitas e habilidades.\n\n### Planeje a produção da ilha\n\nA Wiki apresenta fábricas para diferentes recursos, como carvão, cobre, diamante, ferro, ouro, madeira, gasolina e hidrogênio. Consulte a página de cada fábrica para ver seus requisitos e funcionamento antes de investir nela.\n\n### Desbloqueie novas possibilidades\n\nPontos de Pesquisa fazem parte da progressão e podem ser usados para desbloquear fábricas, melhorar produção e liberar receitas ou habilidades. A documentação lista as atividades relacionadas a cada tipo de pesquisa.\n\n### Automação como escolha estratégica\n\nFábricas ajudam a estruturar a ilha em torno de produção, comércio ou construção. O avanço depende de requisitos documentados; esta apresentação não substitui os valores e passos descritos na Wiki.\n\nDocumentação técnica: https://armamc.net/wiki/skyblock/fabricas/\n\n---\n\n## Dungeons para explorar no Skyblock\n\nURL canônica: https://armamc.net/servidor-minecraft-com-dungeons/\n\nExplore dungeons no Skyblock do Armageddon: áreas temáticas com combate, exploração e desafios descritos nos guias oficiais.\n\nAs dungeons do Skyblock levam os jogadores a áreas de aventura com temas e desafios próprios. A documentação apresenta locais como Biblioteca, Fortaleza, Mansão, Miragem, Piratas, Profundezas e Templo.\n\n### Cada dungeon tem sua identidade\n\nOs guias descrevem cenários e atividades diferentes, incluindo exploração, combate e quebra-cabeças. Consulte a página da dungeon escolhida para informações específicas em vez de presumir que todas funcionam da mesma forma.\n\n### Prepare-se usando as fontes oficiais\n\nOs artigos da Wiki são a referência para detalhes de cada área, mapas e mecânicas documentadas. Verifique os requisitos de entrada e os detalhes da atividade diretamente nos guias.\n\n### Integre aventura e evolução\n\nAs dungeons complementam a construção da ilha, as fábricas, as skills e as missões. Elas oferecem outro caminho para quem quer alternar a gestão de recursos com exploração e combate.\n\nDocumentação técnica: https://armamc.net/wiki/skyblock/dungeons/"
      }
    ],
    "/opt/buildhome/repo/src/plugins/seo-landings/index.js",
    "/opt/buildhome/repo/src/plugins/blog-catalog/index.js",
    "/opt/buildhome/repo/src/plugins/production-source-maps/index.js",
    "/opt/buildhome/repo/src/plugins/rgbirdflop-webpack/index.js"
  ],
  "baseUrlIssueBanner": true,
  "storage": {
    "type": "localStorage",
    "namespace": false
  },
  "future": {
    "v4": {
      "removeLegacyPostBuildHeadAttribute": false,
      "useCssCascadeLayers": false,
      "siteStorageNamespacing": false,
      "fasterByDefault": false,
      "mdx1CompatDisabledByDefault": false
    },
    "faster": {
      "swcJsLoader": false,
      "swcJsMinimizer": false,
      "swcHtmlMinimizer": false,
      "lightningCssMinimizer": false,
      "mdxCrossCompilerCache": false,
      "rspackBundler": false,
      "rspackPersistentCache": false,
      "ssgWorkerThreads": false,
      "gitEagerVcs": false
    },
    "experimental_vcs": {},
    "experimental_router": "browser"
  },
  "onBrokenAnchors": "warn",
  "onDuplicateRoutes": "warn",
  "staticDirectories": [
    "static"
  ],
  "customFields": {},
  "scripts": [],
  "headTags": [],
  "stylesheets": [],
  "clientModules": [],
  "titleDelimiter": "|",
  "noIndex": false
};
